<div [ngClass]="{ difuminar_Fondo: loadingMinute }">
    <div #htmlData id="htmlData">
        <mat-card id="borde1" appearance="outlined" class="borde_card">
            <!--<mat-card-header>
              <mat-card-title></mat-card-title>
              <mat-card-subtitle></mat-card-subtitle>
            </mat-card-header>-->
            <mat-card-content>
              
                <div>
                    <!--<div id="htmlLogo" class="logo" style="justify-content: flex-end;">
                        <img width="158px" height="48px" style="opacity: 0.6; margin-bottom: 45px;" src="../../../../../../../assets/images/logos/dark-logo.png">
                    </div>-->
                    <div class="info_User">
                        <div class="row">
                            <div class="col-md-5">
                                <h2 id="name">  
                                    {{
                                        minuteRequestClient?.name
                                            ? minuteRequestClient.name
                                            : "Cargando..."
                                    }}
                                    <a
                                        matTooltip="Ver Cliente"
                                        href="{{ pathInfoClient }}"
                                        target="_blank">
                                        <i-tabler name="info-circle" class="icon-20 m-r-8"></i-tabler>
                                    </a>
                                    <a *ngIf="resolutionName == 'Pendiente' || resolutionName == 'Pre-Aprobado' || resolutionName == 'En Comité'" style="color: #048801; cursor: pointer;"
                                        matTooltip="Notificar revisor"
                                        (click)="OpenApproversModal()"
                                        >
                                        <i-tabler name="brand-whatsapp" class="icon-20 m-r-8"></i-tabler>
                                    </a>
                                </h2>
                                <h3 id="rut">
                                    {{
                                        minuteRequestClient?.fullRut
                                            ? minuteRequestClient.fullRut
                                            : "-"
                                    }}
                                </h3>
                                <h3 id="aEconomica">
                                    {{
                                        minuteRequestClient?.currentEconomicActivity
                                            ? minuteRequestClient.currentEconomicActivity
                                            : "Actividad No Registrada"
                                    }}
                                </h3>
                                <h3 id="direccion">
                                    {{
                                        minuteRequestClient?.address
                                            ? minuteRequestClient.address
                                            : "Dirección No Registrada"
                                    }}
                                </h3>
                
                                <br >
                                <h3 id="fCreada">
                                    F. Creada:
                                    {{
                                        minuteRequestRealTime?.createdAt
                                            ? (minuteRequestRealTime?.createdAt
                                            | date : "dd/MM/yyyy " : "-06:00")
                                            : "-"
                                    }}   &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;          
                                    Hora:
                                    {{
                                        minuteRequestRealTime?.createdAt
                                        ? (minuteRequestRealTime?.createdAt
                                        | date : "shortTime" : "-06:00") + "Hrs"
                                        : "-"
                                    }}
                                </h3>
                                <h3 id="fExpira">
                                    F. Expira:
                                    {{
                                        minuteRequestRealTime?.dueDate
                                        ? (minuteRequestRealTime.dueDate 
                                        | date : "dd/MM/yyyy")
                                        : "-"
                                    }}
                                    <fa-icon
                                    *ngIf="!minuteRequestRealTime?.isClosed"
                                    (click)="openModalNewDueDate()"
                                    [icon]="icons.faPen"
                                    style="
                                        cursor: pointer;
                                        font-size: 16px;
                                        margin-left: 1rem;
                                    "
                                    ></fa-icon>
                                </h3>
                                <h3>
                                    F. Resolucion:
                                    {{
                                        minuteRequestRealTime?.resolutedAt ? 
                                        (minuteRequestRealTime?.resolutedAt | date : "dd/MM/yyyy")
                                        : "-"
                                    }}
                                </h3>
                                <!--<h3 id="fInicioActividades">
                                    F. Inicio Actividades:
                                </h3>-->
                            </div>
                            <div class="col-md-3">
                                <mat-card class="card-log">
                                    <section class="log-card-content">
                                      <div class="log-date-section log-content-section">
                                        <span>Linea SAGR</span>
                                      </div>
                                      <div class="log-content-section">
                                        <span>
                                            {{
                                                minuteRequestClient?.legacyData?.linea
                                                ? (minuteRequestClient?.legacyData?.linea
                                                | currency : "CLP" : "symbol")
                                                : "$0"
                                            }}
                                            /
                                            {{
                                                minuteSnapshot?.usedWarrantyLine
                                                ? (minuteSnapshot.usedWarrantyLine
                                                | currency : "CLP" : "symbol")
                                                : "$0"
                                            }}
                                        </span>    
                                      </div>
                                    </section>
                                </mat-card>

                                <mat-card class="card-log">
                                    <section class="log-card-content">
                                      <div class="log-date-section log-content-section">
                                        <span>Linea Factoring</span>
                                      </div>
                                      <div class="log-content-section">
                                        <span>
                                            {{
                                                minuteSnapshot?.availableLine
                                                ? (minuteSnapshot.availableLine + minuteSnapshot?.usedLine
                                                | currency : "CLP" : "symbol")
                                                : "$0"
                                            }}
                                        </span>    
                                      </div>
                                    </section>
                                  </mat-card>
                            </div>
                            <div class="col-md-4">
                                <div id="qr" class="col-md-4" style="float: right;"> 
                                    <qrcode
                                        [qrdata]="myAngularxQrCode"
                                        [width]="90"
                                        [errorCorrectionLevel]="'M'">
                                    </qrcode>
                                    <h2 style="color: #003c8a;">
                                       N° {{ minuteRequestId }} 
                                       
                                    </h2>
                                    <div [ngSwitch]="resolutionName" class="resolution">
                                        <p *ngSwitchCase="'Pendiente'" class="resolution-status pending">Pendiente</p>
                                        <p *ngSwitchCase="'Aprobado'" class="resolution-status approved">Aprobada</p>
                                        <p *ngSwitchCase="'Rechazado'" class="resolution-status rejected">Rechazada</p>
                                        <p *ngSwitchCase="'Eliminada'" class="resolution-status rejected">Eliminada</p>
                                        <p *ngSwitchCase="'Cancelada'" class="resolution-status rejected">Cancelada</p>
                                        <p *ngSwitchCase="'En Borrador'" class="resolution-status draft">Borrador</p>
                                        <p *ngSwitchCase="'Pre-Aprobado'" class="resolution-status pre-approved">Pre-Aprobada</p>
                                        <p *ngSwitchCase="'En Comité'" class="resolution-status comitee">En Comité</p>
                                        <p *ngSwitchDefault class="resolution-status">{{resolutionName}}</p>
                                    </div>
                                    <div style="width: 100%; text-align: center; color: #003c8a;">
                                        <h4 style="text-decoration: underline;">Originador</h4>
                                        <h4 id="UserCreated" *ngIf="minuteSnapshot?.createdBy">
                                            {{
                                                minuteSnapshot.createdBy.userName
                                            }}
                                        </h4>
                                        <h4 id="UserCreated" *ngIf="!minuteSnapshot?.createdBy">
                                            S/Info
                                        </h4>
                                    </div>
                                </div>
                                
                            </div>
                        </div>
                    </div>
                
                    <div class="contenedor_Presentacion">
                        <div class="row">
                            <div class="col-md-5">
                                <h2>Presentación</h2>
                            </div>
                            <div id="htmlBtnEditPresentacion" class="col-md-7 btn-container">
                                <button mat-raised-button color="primary" (click)="mostrarActualizarDescripcion()" *ngIf="!minuteRequestRealTime?.isClosed">
                                    Editar          
                                    <fa-icon
                                        [icon]="icons.faPen"
                                        style="cursor: pointer; font-size: 16px; margin-left: 1rem">
                                    </fa-icon>  
                                </button>
                            </div>
                        </div>
                        <hr />
                        <div>
                            <span class="presentacion">
                                {{
                                    minuteRequestRealTime?.description
                                    ? minuteRequestRealTime.description
                                    : "No se ha incluido una descripción"
                                }}
                            </span>
                        </div>
                    </div>
                
                    <div class="contenedor_Comite">
                        <h2>Comité</h2>
                        <hr />
                        <div>
                            <div class="row">
                                <div class="col-md-6">
                                    <h3 class="space_title">Factoring</h3>
                                </div>
                                <div id="htmlBtnAgregarOperacion" class="col-md-6 btn-container">
                                    <button mat-raised-button color="primary" (click)="openDialogToAddInvoiceOperations()" *ngIf="!minuteRequestRealTime?.isClosed">Agregar Operacion</button>
                                </div>
                            </div> 
                            <hr class="hrComite" />
                            <div>               
                                <!--<h3 class="space_title" style="text-decoration: underline;">Operaciones</h3>-->
                                <div> 
                                    <p>
                                        <b>Nueva línea solicitada: </b>
                                        <span *ngIf="minuteRequestRealTime?.hasChangeLineRequest; else noLineChange">
                                            {{minuteRequestRealTime?.factoringLine | currency : "CLP" : "symbol"}}
                                        </span>
                                        <fa-icon
                                        *ngIf="!minuteRequestRealTime?.isClosed"
                                        (click)="openMinuteRequestLine(0)"
                                        [icon]="icons.faPen"
                                        style="
                                            cursor: pointer;
                                            font-size: 16px;
                                            margin-left: 1rem;
                                        "
                                        ></fa-icon>
                                    </p>
                                    <app-operation-list *ngIf="!minuteRequestRealTime?.isClosed || (minuteRequestRealTime?.isClosed && minuteRequestRealTime?.operations.length>0)"
                                        [operations]="minuteRequestRealTime?.operations"
                                        [forMinute]="true"
                                        (invoiceOperationToRemove)="removeInvoiceOperationToMinute($event)"
                                        (invoiceOperationToUpdate)="updateInvoiceOperation($event)">
                                    </app-operation-list>
                                </div>
                            </div>
                        </div> <br >
                
                        <div>
                            <div class="row">
                                <div class="col-md-6">
                                    <h3 class="space_title">Garantías</h3>
                                </div>
                                <div id="htmlBtnAgregarGarantia" class="col-md-6 btn-container">
                                    <button mat-raised-button color="primary" (click)="openDialogToAddWarranties()" *ngIf="!minuteRequestRealTime?.isClosed">Agregar Garantía</button>
                                </div>
                            </div>
                            <hr class="hrComite" />
                            <div>
                                <p>
                                    <b>Nueva línea solicitada: </b>
                                    <span *ngIf="minuteRequestRealTime?.hasChangeWarrantyLineRequest; else noLineChange">
                                        {{                
                                            minuteRequestRealTime?.warrantyLine
                                            | currency : "CLP" : "symbol"
                                        }}    
                                    </span>
                                    <fa-icon
                                        *ngIf="!minuteRequestRealTime?.isClosed"
                                        (click)="openMinuteRequestLine(1)"
                                        [icon]="icons.faPen"
                                        style="cursor: pointer; font-size: 16px; margin-left: 1rem;">
                                    </fa-icon>
                                </p>
                                <app-warranties-minute *ngIf="!minuteRequestRealTime?.isClosed || (minuteRequestRealTime?.isClosed && minuteSnapshot?.warranties.length>0)"
                                    [warranties]="minuteSnapshot?.warranties"
                                    [forMinute]="true"
                                    (warrantiesToRemove)="removeWarrantiesFromMinute($event)"
                                    (invoiceOperationToUpdate)="updateInvoiceWarranties($event)"
                                    (notify)="updateMinutes()"
                                    >
                                </app-warranties-minute>
                            </div>
                        </div><br >
                
                        <div>
                            <div class="row">
                                <div class="col-md-5">
                                    <h3 class="space_title">Deudores</h3>
                                </div>
                                <div id="htmlBtnAprobarAllDebtors" class="col-md-7 btn-container">
                                    <button *ngIf="canApproveAllDebtors() && !minuteRequestRealTime?.isClosed" mat-raised-button color="primary" (click)="approveAllDebtors()">
                                        Aprobar todos
                                    </button>
                                </div>
                            </div>
                            <hr class="hrComite" />
                            <div>
                                <app-debtors-minute id="htmlDebtorMinute"
                                    [minuteRequestId]="minuteRequestId"
                                    [minuteDebtorResolutions]="minuteDebtors"
                                    [canChangeResolution]="!minuteRequestRealTime?.isClosed">
                                </app-debtors-minute>
                                <app-debtors-minute-pdf id="htmlDebtorMinutePdf" class="oculto"
                                    [minuteRequestId]="minuteRequestId"
                                    [minuteDebtorResolutions]="minuteDebtors"
                                    [canChangeResolution]="!minuteRequestRealTime?.isClosed">
                                </app-debtors-minute-pdf>
                            </div>
                        </div>
                
                    </div>
                
                    <div class="contenedor_resolucion">
                        <h2>Resolución</h2>
                        <hr />
                        <div class="row">
                            <div class="col-md-5">
                                <h3 class="space_title">Condiciones especiales</h3>
                            </div>
                            <div class="col-md-7 btn-container" *ngIf="!minuteRequestRealTime?.isClosed">
                                <button matTooltip="Remover" (click)="openManangeMinuteRequestConditions()" mat-raised-button color="primary">
                                    <fa-icon [icon]="faIcons.faPlus"></fa-icon>
                                    Nuevas condiciones
                                </button>
                            </div>                                    
                        </div>
                        <hr class="hrComite" />
                        <div class="row" style="margin-top: 20px;">
                            <div class="col-md-12">
                                <div class="conditions-section">
                                    <section class="conditions-list">
                                        @for(specialCondition of minuteRequestRealTime?.specialConditions; track specialCondition) {
                                            <div class="condition-item">
                                                @if(!minuteRequestRealTime?.isClosed){
                                                    <button *ngIf="!isConditionProcessing(specialCondition.minuteRequestMinuteConditionId); else processingSpinner"
                                                    (click)="removeMinuteConditionFromMinute(specialCondition.minuteRequestMinuteConditionId)" 
                                                    mat-icon-button color="warn">
                                                        <mat-icon>delete</mat-icon>
                                                    </button>
                                                } @else {
                                                    <mat-checkbox *ngIf="!isConditionProcessing(specialCondition.minuteRequestMinuteConditionId); else processingSpinner"
                                                    (change)="canMarkMinuteRequestConditionAsWatched() ?
                                                    checkboxMarkMinuteRequestConditionAsWatched($event, specialCondition.minuteRequestMinuteConditionId) : $event.source.checked = !$event.source.checked"
                                                    [ngClass]="{'readonly-condition-checkbox': !canMarkMinuteRequestConditionAsWatched()}"
                                                    [checked]="specialCondition.isReviewed">
                                                    </mat-checkbox>    
                                                }
                                                <div class="content">
                                                    <b>{{specialCondition.conditionName}}</b>
                                                    <span>{{specialCondition.description}}</span>    
                                                </div>                                                
                                            </div>
                                        }@empty {
                                            <!-- Manejar logica de condicion antigua-->
                                            @if(minuteRequestRealTime?.hasConditions) {
                                                <span class="hasConditionSpan">
                                                    <fa-icon size="xl"
                                                    [style.color]="'orange'"
                                                    [icon]="faIcons.faTriangleExclamation"></fa-icon>
                                                    Tiene condiciones especiales
                                                </span>
                                            } @else {
                                                <span>
                                                    <fa-icon size="xl" [style.color]="'gray'" [icon]="faIcons.faCircleMinus"></fa-icon>
                                                    Sin condiciones especiales
                                                </span>    
                                            }
                                        }
                                    </section>
                                    <!-- <mat-checkbox *ngIf="!minuteRequestRealTime?.isClosed" [disabled]="disableHasConditionChk" [checked]="minuteRequestRealTime?.hasConditions"
                                    (change)="changeHasConditions($event)">
                                        <span class="hasConditionSpan">Tiene condiciones especiales</span>
                                    </mat-checkbox>
                                    <span class="hasConditionSpan" *ngIf="minuteRequestRealTime?.isClosed">
                                        <fa-icon size="xl"
                                        [style.color]="minuteRequestRealTime?.hasConditions ? 'orange': 'gray'"
                                        [icon]="minuteRequestRealTime?.hasConditions ? faIcons.faTriangleExclamation : faIcons.faCircleMinus">
                                    </fa-icon>
                                        {{ minuteRequestRealTime?.hasConditions? 'Tiene condiciones especiales' : 'Sin condiciones especiales'}}
                                    </span> -->
                                </div>
                                <div class="row">
                                    <div *ngFor="let resolution of minuteRequestRealTime?.resolutions" class="section_info_approve col-md-4">
                                        <app-minute-resolution-item
                                            [minuteResolution]="resolution">
                                        </app-minute-resolution-item>
                                    </div>
                                    <div *ngIf="minuteRequestRealTime?.resolutions.length<1" class="col-md-6">
                                        <p>Sin Resolucion</p>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <section class="section_info">
                            <h4 *ngIf="!minuteRequestRealTime?.resolutions">No hay info</h4>
                        </section>
                    </div>
                </div>
        
            </mat-card-content>
        </mat-card>
        
        <br >
        
        <mat-card id="borde2" appearance="outlined" class="borde_card">
            <mat-card-content>
                <div>
                    <div class="contenedor_Composicion_Legal" *ngIf="isCompany == true ;">
                        <div style="width: 100%;">
                            <div class="row">
                                <div class="col-md-5">
                                    <h2>Composición legal</h2>
                                </div>
                                <div id="htmlBtnConsultaDicom" class="col-md-7 btn-container" *ngIf="!minuteRequestRealTime?.isClosed && hasDicomPermission">
                                    <button mat-raised-button color="primary" (click)="getDicomPartners()">
                                    Consulta DICOM
                                    </button>
                                </div>
                            </div>
                            <hr />
                            <div style="width: 100%;">
                                <section class="Owners">
                                    <app-minute-owners
                                        [minuteRequestRealTime]="minuteRequestRealTime"
                                        [minuteOwnersRequest]="minuteOwnersRequest"
                                        [forMinute]="true"
                                    ></app-minute-owners>
                                </section>
                            </div>
                        </div>
                    </div>
                
                    <div class="contenedor_MP">
                        <h2>Mercado Público</h2>
                        <hr />
                        <div class="row">
                            <div class="col-md-6">
                                <p id="fechamp:"> <b>Fecha de inicio en MP: </b>
                                    {{
                                        minuteRequestClient?.startMP
                                        ? (minuteRequestClient.startMP | date : "dd-MM-yyyy")
                                        : "-"
                                    }}
                                </p>
                                <p id="adjudicacionm"> <b>Adjudicación máxima: </b>
                                    {{
                                        minuteRequestClient?.mp
                                        ? (minuteRequestClient?.mp?.maxAdjudication
                                            | currency : "CLP" : "symbol")
                                        : "-"
                                    }}
                                </p>
                            </div>
                            <div class="col-md-6">
                                <p id="telefono"> <b>Primera adjudicación: </b>
                                    {{
                                        minuteRequestClient?.mp
                                        ? (minuteRequestClient?.mp?.firstAdjudication
                                            | date : "dd-MM-yyyy")
                                        : "-"
                                    }}
                                </p>
                                <p id="telefono"> <b>Primera adjudicación desde ahora: </b>
                                    {{
                                        minuteRequestClient?.mp
                                        ? (minuteRequestClient?.mp?.firstAdjudicationFromNow
                                            | number) +
                                            " Dias (" +
                                            transformDayToMonth(
                                            minuteRequestClient?.mp?.firstAdjudicationFromNow
                                            ) +
                                            " Meses)"
                                        : "-"
                                    }}
                                </p>
                            </div>
                        </div>
                    </div>
                
                    <div class="contenedor_SAGR">
                        <h2>INGE Corredores de seguros y SAGR</h2>
                        <hr />
                        <div class="row" *ngIf="minuteRequestClient?.legacyData">
                            <div class="col">
                                <p>
                                    <b>Línea: </b>
                                    {{
                                        minuteRequestClient?.legacyData?.linea
                                        | currency : "CLP" : "symbol"
                                    }}
                                </p>
                                <p>
                                    <b>Línea disponible: </b>
                                    {{
                                        minuteRequestClient?.legacyData?.availableLine
                                        | currency : "CLP" : "symbol"
                                    }}
                                </p>
                                <p>
                                    <b>Línea total utilizada: </b>
                                    {{
                                        minuteRequestClient?.legacyData?.totalUsedLine
                                        | currency : "CLP" : "symbol"
                                    }}
                                </p>
                                <p>
                                    <b>Riesgo total asumido: </b>
                                    {{
                                        minuteRequestClient?.legacyData?.totalRiskTaken
                                        | currency : "CLP" : "symbol"
                                    }}
                                </p>
                                <p>
                                    <b>Cantidad total de garantías: </b>
                                    {{
                                        minuteRequestClient?.legacyData?.totalWarrantiesCount
                                        | number
                                    }}
                                </p>
                                </div>
                                <div class="col">
                                    <p>
                                        <b>Fecha de creación: </b>
                                        {{
                                            minuteRequestClient?.legacyData?.inserted
                                            | date : "dd-MM-yyyy"
                                        }}
                                    </p>
                                    <p>
                                        <b>Ejecutivo: </b>
                                        {{ minuteRequestClient?.legacyData?.executive }}
                                    </p>
                                    <p>
                                        <b>Último scoring: </b>
                                        {{
                                            minuteRequestClient?.legacyData?.lastScoringStateDescription
                                        }}
                                    </p>
                                <p>
                                    <b>Garantías vigentes: </b>
                                    {{
                                        minuteRequestClient?.legacyData?.availableWarrantiesCount | number
                                    }}
                                </p>
                            </div>
                        </div>
                        <div *ngIf="!minuteRequestClient?.legacyData">
                            <p>No es Cliente INGE</p>
                        </div>
                    </div>
                
                    <div class="contenedor_Formula">
                        <h2>Fórmula Factoring</h2>
                        <hr />
                        <div class="row">
                            <div class="col">
                                <p>
                                    <b>Línea: </b>
                                    {{
                                        minuteSnapshot?.availableLine
                                            ? (minuteSnapshot.availableLine + minuteSnapshot?.usedLine
                                            | currency : "CLP" : "symbol")
                                            : "$0"
                                    }}
                                </p>
                                <p>
                                    <b>Línea disponible: </b>
                                    {{
                                        minuteSnapshot?.availableLine
                                            ? (minuteSnapshot.availableLine
                                            | currency : "CLP" : "symbol")
                                            : "$0"
                                    }}
                                </p>
                                <p>
                                    <b>Línea utilizada: </b>
                                    {{
                                        minuteSnapshot?.usedLine
                                            ? (minuteSnapshot.usedLine * -1
                                            | currency : "CLP" : "symbol")
                                            : "$0"
                                    }}
                                </p>
                            </div>
                            <div class="col">
                                <p>
                                    <b>Facturas cedidas: </b>
                                    {{
                                        minuteRequestClient?.invoicesTransferFormula
                                        ? minuteRequestClient.invoicesTransferFormula
                                        : ("0" | number)
                                    }}
                                </p>
                                <p>
                                    <b>Monto total cedido:</b>
                                    {{
                                    minuteRequestClient?.tgr?.amount
                                        ? (minuteRequestClient.tgr.amount
                                        | currency : "CLP" : "symbol")
                                        : "$0"
                                    }}
                                </p>
                            </div>
                        </div>
                    </div>
                
                    <div class="contenedor_Actives">
                        <h2>Activos y pasivos</h2>
                        <hr />
                        <div class="actives-header">
                            <div class="row">
                                <div class="col-md-12 a row">
                                    <div class="col-md-3">
                                        <div class="grafics_min_blue" style="margin-bottom: 3px;">
                                            <h3 style="margin-bottom: 8px;">CMF (SBIF)</h3>
                                            <h3 *ngIf="datosCMF?.totalVigente != null">
                                                {{
                                                    datosCMF?.totalVigente
                                                    ? (datosCMF.totalVigente
                                                    | currency : "CLP" : "symbol") + '.000'
                                                    : "$0"
                                                }}
                                            </h3>
                                            <h3 *ngIf="datosCMF?.totalVigente == null">
                                                S/Info
                                            </h3>
                                            <h4>Vigente</h4>
                                        </div> <br >
                                        <div id="htmlCmfVencida" class="grafics_min_green green">
                                            <h3 style="margin-bottom: 8px;">CMF(SBIF)</h3>
                                            <h3 *ngIf="datosCMF?.totalVencida != null">
                                                {{
                                                    datosCMF?.totalVencida
                                                    ? (datosCMF.totalVencida
                                                    | currency : "CLP" : "symbol") + '.000'
                                                    : "$0"
                                                }}
                                            </h3>
                                            <h3 *ngIf="datosCMF?.totalVencida == null">
                                                S/Info
                                            </h3>
                                            <h4>Vencida</h4>
                                        </div>
                                    </div>
                                    <div class="col-md-3">
                                        <div id="htmlCmfMorosa" class="grafics_min_green green">
                                            <h3 style="margin-bottom: 8px;">CMF (SBIF)</h3>
                                            <h3 *ngIf="datosCMF?.totalMorosa != null">
                                                {{
                                                    datosCMF?.totalMorosa
                                                    ? (datosCMF.totalMorosa
                                                    | currency : "CLP" : "symbol") + '.000'
                                                    : "$0"
                                                }}
                                            </h3>
                                            <h3 *ngIf="datosCMF?.totalMorosa == null">
                                                S/Info
                                            </h3>
                                            <h4>Morosa</h4>
                                        </div> <br >
                                        <div id="htmlCmfCastigada" class="grafics_min_green green">
                                            <h3 style="margin-bottom: 8px;">CMF(SBIF)</h3>
                                            <h3 *ngIf="datosCMF?.totalCastigada != null">
                                                {{
                                                    datosCMF?.totalCastigada
                                                    ? (datosCMF.totalCastigada
                                                    | currency : "CLP" : "symbol") + '.000'
                                                    : "$0"
                                                }}
                                            </h3>
                                            <h3 *ngIf="datosCMF?.totalCastigada == null">
                                                S/Info
                                            </h3>
                                            <h4>Castigada</h4>
                                        </div>
                                    </div>
                
                                    <div class="col-md-3">
                                        <div class="grafics_min_blue">
                                            <h3 style="margin-bottom: 8px;">TGR</h3>
                                            <h3 *ngIf="datosTgr?.amountVigente != null">
                                                {{
                                                    datosTgr?.amountVigente
                                                    ? (datosTgr.amountVigente
                                                    | currency : "CLP" : "symbol")
                                                    : "$0"
                                                }}
                                            </h3>
                                            <h3 *ngIf="datosTgr?.amountVigente == null">
                                                S/Info
                                            </h3>
                                            <h4>Vigente</h4>
                                        </div> <br >
                                        <div class="grafics_min_blue" style="margin-bottom: 3px;">
                                            <h3 style="margin-bottom: 8px;">TGR</h3>
                                            <h3 *ngIf="datosTgr?.amountConvenio != null">
                                                {{
                                                    datosTgr?.amountConvenio
                                                    ? (datosTgr.amountConvenio
                                                    | currency : "CLP" : "symbol")
                                                    : "$0"
                                                }}
                                            </h3>
                                            <h3 *ngIf="datosTgr?.amountConvenio == null">
                                                S/Info
                                            </h3>
                                            <h4>Con Convenio</h4>
                                        </div>
                                    </div>
                                    <div class="col-md-3">
                                        <div id="htmlTgrMorosa" class="grafics_min_green">
                                            <h3 style="margin-bottom: 8px;">TGR</h3>
                                            <h3 *ngIf="datosTgr?.amountMorosa != null">
                                                {{
                                                    datosTgr?.amountMorosa
                                                    ? (datosTgr.amountMorosa
                                                    | currency : "CLP" : "symbol")
                                                    : "$0"
                                                }}
                                            </h3>
                                            <h3 *ngIf="datosTgr?.amountMorosa == null">
                                                S/Info
                                            </h3>
                                            <h4>Morosa</h4>
                                        </div> <br >
                                    </div>
                                </div>
                            </div> <br >
                            <div class="row">
                                <div class="col-md-12 row">
                                    <div class="col-md-6" >
                                        <div id="htmlEquifax" #htmlEquifax class="grafics_green">
                                            <div class="row">
                                                <div class="col-md-12" style="margin-top: 5px;">
                                                    <h3 style="margin-bottom: 15px;">EQUIFAX</h3>
                                                </div>
                                                <div class="col-md-4">
                                                    <div id="htmlEquifaxPuntaje" style="top: 60%; color: #048801;">
                                                        <h3 *ngIf="minuteRequestClient?.dicom?.puntaje">{{ minuteRequestClient?.dicom?.puntaje }}</h3>
                                                        <h3 *ngIf="minuteRequestClient?.dicom?.puntaje==null || minuteRequestClient?.dicom?.puntaje==''">S/Info</h3>
                                                        <h5>Puntaje</h5>
                                                    </div>
                                                    <!--<div style="top: 60%;">
                                                        <h3>    
                                                            <a
                                                                href="{{ pathUrlDicom }}"
                                                                target="_blank"
                                                                style="font-weight: normal; color: #34425a">
                                                                <mat-icon matSuffix class="dicomReport">feed</mat-icon>
                                                            </a>
                                                        </h3>
                                                        <h5>Reporte</h5>
                                                    </div>-->
                                                </div>
                                                <div class="col-md-4">
                                                    <div id="htmlEquifaxBcom" style="color: #048801;">
                                                        <h3 *ngIf="minuteRequestClient?.dicom?.totaL_BOLCOM !== undefined && minuteRequestClient?.dicom?.totaL_BOLCOM !== null">
                                                            {{ minuteRequestClient?.dicom?.totaL_BOLCOM | currency : "CLP" : "symbol" }}
                                                        </h3>
                                                        <h3 *ngIf="minuteRequestClient?.dicom?.totaL_BOLCOM === undefined || minuteRequestClient?.dicom?.totaL_BOLCOM === null">
                                                            S/Info
                                                        </h3>
                                                        <h5>B.COM</h5>
                                                    </div>
                                                    <div id="htmlEquifaxIcom" style="color: #048801;">
                                                        <h3 *ngIf="minuteRequestClient?.dicom?.totaL_ICOM !== undefined && minuteRequestClient?.dicom?.totaL_ICOM !== null">
                                                            {{ minuteRequestClient?.dicom?.totaL_ICOM | currency : "CLP" : "symbol" }}
                                                        </h3>
                                                        <h3 *ngIf="minuteRequestClient?.dicom?.totaL_ICOM === undefined || minuteRequestClient?.dicom?.totaL_ICOM === null">
                                                            S/Info
                                                        </h3>  
                                                        <h5>I.COM</h5>
                                                    </div>
                                                </div>
                                                <div class="col-md-4">
                                                    <div id="htmlEquifaxBed" style="color: #048801;">
                                                        <h3 *ngIf="minuteRequestClient?.dicom?.totaL_BED !== undefined && minuteRequestClient?.dicom?.totaL_BED !== null">
                                                            {{ minuteRequestClient?.dicom?.totaL_BED | currency : "CLP" : "symbol" }}
                                                        </h3>
                                                        <h3 *ngIf="minuteRequestClient?.dicom?.totaL_BED === undefined || minuteRequestClient?.dicom?.totaL_BED === null">
                                                            S/Info
                                                        </h3>  
                                                        <h5>BED</h5>
                                                    </div>
                                                    <div id="htmlEquifaxBlab" style="color: #048801;">
                                                        <h3 *ngIf="minuteRequestClient?.dicom?.totaL_BOLAB !== undefined && minuteRequestClient?.dicom?.totaL_BOLAB !== null">
                                                            {{ minuteRequestClient?.dicom?.totaL_BOLAB | currency : "CLP" : "symbol" }}
                                                        </h3>
                                                        <h3 *ngIf="minuteRequestClient?.dicom?.totaL_BOLAB === undefined || minuteRequestClient?.dicom?.totaL_BOLAB === null">
                                                            S/Info
                                                        </h3>
                                                          
                                                        <h5>B.LAB</h5>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                    <div class="col-md-6">
                                        <div class="grafics_blue" style="padding-top: 0px;">
                                            <div class="row">
                                                <div class="col-md-12" style="margin-top: 5px;">
                                                    <h3 style="margin-bottom: 15px;">EQUIFAX</h3>
                                                </div>
                                                <div class="col-md-6">
                                                    <div>
                                                        <h3>
                                                            {{ 
                                                                minuteRequestClient?.dicom?.f_TOTAL_VEHICULOS
                                                                ? (minuteRequestClient.dicom.f_TOTAL_VEHICULOS)
                                                                : "S/Info"
                                                            }}
                                                        </h3>
                                                        <h5>Vehiculos($)</h5>
                                                    </div>
                                                    <div>
                                                        <h3>
                                                            {{
                                                                minuteRequestClient?.dicom?.f_TOTAL_PROPIEDADES
                                                                ? (minuteRequestClient.dicom.f_TOTAL_PROPIEDADES)
                                                                : "S/Info"
                                                            }}
                                                        </h3>
                                                        <h5>Propiedades($)</h5>
                                                    </div>
                                                </div>
                                                <div class="col-md-6">
                                                    <div>
                                                        <h3>{{
                                                                minuteRequestClient?.dicom?.n_VEHICULOS
                                                                ? (minuteRequestClient.dicom.n_VEHICULOS)
                                                                : "S/Info"
                                                            }}
                                                        </h3>
                                                        <h5>Vehiculos(N)</h5>
                                                    </div>
                                                    <div>
                                                        <h3>
                                                            {{
                                                                minuteRequestClient?.dicom?.n_PROPIEDADES
                                                                ? (minuteRequestClient.dicom.n_PROPIEDADES)
                                                                : "S/Info"
                                                            }}
                                                        </h3>
                                                        <h5>Propiedades(N)</h5>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                
                    <div class="contenedor_Compras_Ventas">
                        <h2>Compras y Ventas (SII)</h2>
                        <hr />
                        <h3 class="space_title">Informacion SII</h3>
                        <hr class="hrComite" />
                        <div class="row">
                            <div class="col">
                                <p>
                                    <b>Cliente enrolado: </b>
                                    {{ minuteRequestClient?.siiConnected ? "Sí" : "No" }}
                                </p>
                                <p>
                                    <b>PYME: </b>
                                    {{ minuteRequestClient?.isPyme ? "Sí" : "No" }}
                                </p>
                            </div>
                            <div class="col">
                                <p>
                                    <b>Fogape:</b>
                                    {{ minuteRequestClient?.fogape ? "Sí" : "No" }}
                                </p>
                                <div *ngIf="minuteRequestClient?.availablePrograms">
                                    <p *ngFor="let program of minuteRequestClient.availablePrograms">
                                        <b>Programas Pre-Elegibles</b>
                                        {{
                                            program 
                                        }}
                                    </p>
                                </div>
                            </div>
                        </div>
                        <h3 class="space_title" *ngIf="minuteRequestClient?.siiConnected">KPI's</h3>
                        <div class="row" *ngIf="minuteRequestClient?.siiConnected">
                            <hr class="hrComite" />
                            <div class="col-md-12">
                                <div class="grafics_blue_KPI">
                                    <div class="row">
                                        <div class="col-md-12" style="padding: 5px;">
                                            <h3>12 Meses</h3>
                                        </div>
                                        <div class="col-md-6 row">
                                            <div class="col-md-12" style="padding-bottom: 28px;">
                                                <h3 style="text-decoration: underline;">Ventas</h3>
                                            </div>
                                            <div class="col-md-6 s">
                                                <h3 *ngIf="minuteRequestClient?.companySummary12M != null">
                                                    {{ 
                                                        minuteRequestClient?.companySummary12M?.sellInvoiceAmount  
                                                        ? (minuteRequestClient.companySummary12M.sellInvoiceAmount  
                                                        | currency : "CLP" : "symbol")
                                                        : "$0"
                                                    }}
                                                </h3>
                                                <h3 *ngIf="minuteRequestClient?.companySummary12M == null">
                                                    S/Info
                                                </h3>
                                                <h5>Monto($)</h5>
                                            </div>
                                            <div class="col-md-6 s">
                                                <h3 *ngIf="minuteRequestClient?.companySummary12M != null">
                                                    {{ 
                                                        minuteRequestClient?.companySummary12M?.numberSellInvoices 
                                                        ? (minuteRequestClient.companySummary12M.numberSellInvoices)
                                                        : "0"
                                                    }}
                                                </h3>
                                                <h3 *ngIf="minuteRequestClient?.companySummary12M == null">
                                                    S/Info
                                                </h3>
                                                <h5>Documentos(N)</h5>
                                            </div>
                                        </div>
                                        <div class="col-md-6 row">
                                            <div class="col-md-12" style="padding-top: 5px;">
                                                <h3 style="text-decoration: underline; padding-bottom: 28px;">Compras</h3>
                                            </div>
                                            <div class="col-md-6 s">
                                                <h3 *ngIf="minuteRequestClient?.companySummary12M != null">
                                                    {{
                                                        minuteRequestClient?.companySummary12M?.buyInvoiceAmount 
                                                        ? (minuteRequestClient.companySummary12M.buyInvoiceAmount 
                                                        | currency : "CLP" : "symbol")
                                                        : "$0"
                                                    }}
                                                </h3>
                                                <h3 *ngIf="minuteRequestClient?.companySummary12M == null">
                                                    S/Info
                                                </h3>
                                                <h5>Monto($)</h5>
                                            </div>
                                            <div class="col-md-6 s">
                                                <h3 *ngIf="minuteRequestClient?.companySummary12M != null">
                                                    {{ 
                                                        minuteRequestClient?.companySummary12M?.numberBuyInvoices
                                                        ? (minuteRequestClient.companySummary12M.numberBuyInvoices)
                                                        : "0"
                                                    }}
                                                </h3>
                                                <h3 *ngIf="minuteRequestClient?.companySummary12M == null">
                                                    S/Info
                                                </h3>
                                                <h5>Documentos(N)</h5>
                                            </div>
                                        </div>
                                    </div>
                                </div> <br >
                            </div>
                            <div class="col-md-12">
                                <div class="grafics_blue_KPI">
                                    <div class="row">
                                        <div class="col-md-12" style="padding: 5px;">
                                            <h3>24 Meses</h3>
                                        </div>
                                        <div class="col-md-6 row">
                                            <div class="col-md-12" style="padding-bottom: 28px;">
                                                <h3 style="text-decoration: underline;">Ventas</h3>
                                            </div>
                                            <div class="col-md-6 s">
                                                <h3 *ngIf="minuteRequestClient?.companySummary24M != null">
                                                    {{ 
                                                        minuteRequestClient?.companySummary24M?.sellInvoiceAmount   
                                                        ? (minuteRequestClient.companySummary24M.sellInvoiceAmount   
                                                        | currency : "CLP" : "symbol")
                                                        : "$0" 
                                                    }}
                                                </h3>
                                                <h3 *ngIf="minuteRequestClient?.companySummary24M == null">
                                                    S/Info
                                                </h3>
                                                <h5>Monto($)</h5>
                                            </div>
                                            <div class="col-md-6 s">
                                                <h3 *ngIf="minuteRequestClient?.companySummary24M != null">
                                                    {{ minuteRequestClient?.companySummary24M?.numberSellInvoices }}
                                                </h3>
                                                <h3 *ngIf="minuteRequestClient?.companySummary24M == null">
                                                    S/Info
                                                </h3>
                                                <h5>Documentos(N)</h5>
                                            </div>
                                        </div>
                                        <div class="col-md-6 row">
                                            <div class="col-md-12" style="padding-top: 5px;">
                                                <h3 style="text-decoration: underline; padding-bottom: 28px;">Compras</h3>
                                            </div>
                                            <div class="col-md-6 s">
                                                <h3 *ngIf="minuteRequestClient?.companySummary24M != null">
                                                    {{
                                                        minuteRequestClient?.companySummary24M?.buyInvoiceAmount   
                                                        ? (minuteRequestClient.companySummary24M.buyInvoiceAmount   
                                                        | currency : "CLP" : "symbol")
                                                        : "$0"
                                                    }}
                                                </h3>
                                                <h3 *ngIf="minuteRequestClient?.companySummary24M == null">
                                                    S/Info
                                                </h3>
                                                <h5>Monto($)</h5>
                                            </div>
                                            <div class="col-md-6 s">
                                                <h3 *ngIf="minuteRequestClient?.companySummary24M != null">
                                                    {{ minuteRequestClient?.companySummary24M?.numberBuyInvoices }}
                                                </h3>
                                                <h3 *ngIf="minuteRequestClient?.companySummary24M == null">
                                                    S/Info
                                                </h3>
                                                <h5>Documentos(N)</h5>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                
                    <ng-template #noInfo>
                        <span>No hay info</span>
                    </ng-template>
                
                    <ng-template #noLineChange>
                        <span>No solicitado</span>
                    </ng-template>
        
                </div>
            </mat-card-content>
        </mat-card>
        
        
        
        <div id="btnResolutions" class="button-container row">
            <div class="button-aprobacion col-md-7">
                <button *ngIf="showButtons"
                    (click)="approveMinute(minuteRequestRealTime.requestMinuteId)" mat-raised-button color="primary">
                    Aprobar
                </button>

                <button *ngIf="showReviewButtons"
                    mat-raised-button [disabled]="!canApproveMinuteRequestReview()" color="primary" (click)="approveReviewMinute(minuteRequestRealTime?.requestMinuteId)">
                    Aprobar revisión
                </button>

                <button *ngIf="showReviewButtons"
                    (click)="rejectMinute(minuteRequestRealTime.requestMinuteId)" mat-raised-button color="warn">
                    Rechazar revisión
                </button>

                <button *ngIf="showButtons"
                    (click)="rejectMinute(minuteRequestRealTime.requestMinuteId)" mat-raised-button color="warn">
                    Rechazar
                </button>
                <button *ngIf="minuteRequestRealTime?.finalResolutionName == 'Aprobado'" 
                    (click)="deleteMinute(minuteRequestRealTime.requestMinuteId,minuteRequestRealTime?.finalResolutionName)" mat-raised-button color="warn">
                    Anular Minuta
                </button>
                <button *ngIf="!minuteRequestRealTime?.isClosed"
                    (click)="updateMinutes()" mat-raised-button color="accent">
                    Actualizar Minuta
                </button>
            </div>
            <div class="button-options col-md-5">
                <button (click)="closeMinuteConfirmation()" *ngIf="minuteRequestRealTime?.finalResolutionName == 'En Borrador' && !minuteRequestRealTime?.isClosed" 
                    mat-stroked-button color="primary">
                    Enviar a comite
                </button>
                <button *ngIf="minuteRequestRealTime?.finalResolutionName == 'En Borrador'"
                    (click)="deleteMinute(minuteRequestRealTime.requestMinuteId,minuteRequestRealTime?.finalResolutionName)" mat-stroked-button color="warn">
                    Eliminar Minuta
                </button>
                <button *ngIf="minuteRequestRealTime?.isClosed" (click)="createPdf()" mat-stroked-button color="primary">
                    Ver PDF
                    <mat-icon matSuffix>picture_as_pdf</mat-icon>
                </button>
            </div>
        </div>
        
        <div id="btnVolver">
            <button (click)="goBack()" class="d-flex align-items-center m-y-32" type="button"
                mat-stroked-button
                color="primary">
                <span class="span_back">
                    <i-tabler name="chevron-left" class="m-r-8"></i-tabler>
                    <span>Volver</span>
                </span>
            </button>
        </div>
    </div>
</div>

<ng-template #processingSpinner>
    <mat-spinner diameter="25"></mat-spinner>
</ng-template>